export default [
  {
    name: 'projectBoard',
    path: '/projectBoard/search',
    component: () => import('@/views/projectBoard/index.vue'),
    meta: {
      title: '项目看板'
    }
  }
]